import { useEffect, useRef, useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import SubMenu from "../SubMenu";
import styles from "../../Header.module.scss";
import { handleize, makeId } from "@/helpers/userHelpers";
import { reportError } from "@/helpers/errorHelper";

const MenuItem = (props) => {
  const dispatch=useDispatch();
  const isSuperbrandHeroPresent = useSelector(
    (state) => state.header.isSuperbrandHeroPresent
  );
  const submenuToggle=useSelector(
    (state) => state.header.isSubmenuVisible
  );
  const isScroll=useSelector(
    (state) => state.header.isHeaderScroll
  );
  const {index, menuItem} = props
 
  const [isHovered, setIsHovered] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const menuRef = useRef(null);

  useEffect(()=>{
    try{
      //ada - tab indexing for menu
      if(isHovered && activeMenu?.current){
        if(activeMenu?.current){
          activeMenu?.current?.children[1]?.classList?.add("menu-active");
        }
      }else{
        document?.querySelector(".menu-active")?.classList?.remove("menu-active");
      }
    }catch(e){
      reportError("Error in MenuItems ada function : ", e)
    }
  },[isHovered,activeMenu?.current])

  function navigateTo(path, event) {
    event.preventDefault(); // Prevents the default anchor behavior
    window.location.href = path; // Custom navigation logic
  }

  return (
    <li
      key={index}
      className={`${styles.main_nav_impact_class} ${props.isLast?"last-menu-item":props.isSecondLast?"second-last-menu-item":""}`}
      ref={menuRef}
      onFocus={(e)=>{
        setTimeout(() => {
          setIsHovered(true);
          setActiveMenu(menuRef);
        }, 0);
      }}
      onBlur={()=>{
        setTimeout(()=>{
          setIsHovered(false);
          setActiveMenu(null)
        },0)
      }}
      onKeyDown={(event)=>{
        if (event?.key === 'Enter' || event?.key === ' ') {
          setIsHovered((prev) => !prev); 
        }
      }}
    >
      <a
        className={`${isSuperbrandHeroPresent && !submenuToggle && !isScroll?`x-small-md ${styles.super_brand}`:'x-small-md'} ga-4-global menu-item`}
        href={menuItem.navigationLink}
        data-ga4={"Navigation " + menuItem.navigationTitle}
        id={`${handleize(menuItem.navigationTitle)}-${makeId(3)}`}
        tabIndex={0}
        onClick={(event) => navigateTo(menuItem.navigationLink,event)}
      >
        {menuItem.navigationTitle}
      </a>
      {(menuItem?.subMenuColumns &&
        <SubMenu subMenu={menuItem.subMenuColumns} navigationTitle = {menuItem.navigationTitle} subMenuToggle={(submenuToggle || isHovered)} />
      )}
    </li>
  );
};

export default MenuItem;